import React from 'react';

import classNames from 'classnames';

import './Table.scss';
import { mapAllowedChildren } from './util';
import { Table as TableCl } from '@innovationnorway/cl-react';

const Table = ({
  children,
  className,
  ...rest
}: React.HTMLAttributes<HTMLTableElement> & {
  children?: React.ReactNode;
  className?: string;
  [x: string]: any;
}) => {
  const content = mapAllowedChildren(children, ['Thead', 'Tbody', 'Tfoot', 'th', 'tbody']);
  return (
    <TableCl hover className={classNames('table', className)} {...rest}>
      {content}
    </TableCl>
  );
};

export const Thead = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLTableSectionElement> & {
  children?: React.ReactNode;
  [x: string]: any;
}) => {
  const content = mapAllowedChildren(children, ['Tr']);
  return <TableCl.Head {...rest}>{content}</TableCl.Head>;
};

export const Tfoot = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLTableSectionElement> & {
  children?: React.ReactNode;
  [x: string]: any;
}) => {
  const content = mapAllowedChildren(children, ['Tr']);

  return <tfoot {...rest}>{content}</tfoot>;
};

export const Tr = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLTableRowElement> & {
  children?: React.ReactNode;
  [x: string]: any;
}) => {
  const content = mapAllowedChildren(children, ['Th', 'Td']);
  return <TableCl.Row {...rest}>{content}</TableCl.Row>;
};

export const Th = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLTableCellElement> & {
  children?: React.ReactNode;
  className?: string;
  [x: string]: any;
}) => {
  return <TableCl.HeaderCell {...rest}>{children}</TableCl.HeaderCell>;
};

export const Tbody = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLTableSectionElement> & {
  children?: React.ReactNode;
  [x: string]: any;
}) => {
  return <TableCl.Body {...rest}>{children}</TableCl.Body>;
};

export const Td = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLTableCellElement> & {
  children?: React.ReactNode;
  className?: string;
  [x: string]: any;
}) => {
  return <TableCl.Cell {...rest}>{children}</TableCl.Cell>;
};

Table.displayName = 'Table';
Thead.displayName = 'Thead';
Tbody.displayName = 'Tbody';
Tfoot.displayName = 'Tfoot';
Th.displayName = 'Th';
Tr.displayName = 'Tr';
Td.displayName = 'Td';

Table.Head = Thead;
Table.Body = Tbody;
Table.Foot = Tfoot;
Table.Header = Th;
Table.Row = Tr;
Table.Cell = Td;

export default Table;
